import React from 'react';
import ItemSimplesListagem from '../../components/listagem/ItemSimplesListagem';
import Random from "../../utils/strings/Random";

class Listagem extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      exercicios:this.props.exercicios,
      itemClass:"listagem-item",
      itemIdPrefix:"item-exercicio-"
    }
  }

  render (){
    let _exercicios = this.props.exercicios;
    let _prefix = this.state.itemIdPrefix;
    var _listagem = [];

    if(_exercicios){
      _listagem = _exercicios.map((data,i)=>{
        const _value = data.label;
        const _identifier = _prefix+data.value;
        const _id = data.value;

        return (
          <ItemSimplesListagem
            key={i.toString()}
            value={_value}
            id={_id}
            identifier={_identifier}
            btRemoveClick={this.props.btRemoveClick}
            hideEdit={true}>
          </ItemSimplesListagem>
        )
      }
      );//end map
    }

    return(
      <div>{_listagem}</div>
    )
  }
}

export default Listagem;



// WEBPACK FOOTER //
// ./src/classes/blocos/Listagem.js